<template>
    <div class="charts-page">
        <v-tabs class="charts-tabs" :value="currentIndex" @change="selectChart">
            <v-tab v-for="(chart, index) in charts" :key="index" :ripple="false"
                :title="chartTitle(chart)"
                v-click-outside="() => closeTabMenu(index)" ref="tabItem"
            >
                <a href="#" class="tab-options" @click="toggleTabMenu($event, index)"
                   v-if="chart.state === 'view'"
                >
                    <i class="fa fa-ellipsis-h"></i>
                </a>
                <span>{{ chartTitle(chart) }}</span>
                <a href="#" class="tab-close" v-if="charts.length > 1" @click="removeChart($event, index)">
                    <i class="fa fa-times"></i>
                </a>
            </v-tab>
            <div class="add-new-tab" @click="addChart">+</div>
            <v-tab-item v-for="(chart, index) in charts" :key="index" :transition="false" :reverse-transition="false">
                <Chart :chart="chart" :initialHeight="chartInitialHeight"  :initialWidth="chartInitialWidth":key="chart.chartId"></Chart>
            </v-tab-item>
        </v-tabs>
        <div class="charts-tab-options">
            <div class="tab-options-menu" v-for="(chart, index) in viewCharts"
                :key="index" :class="{ open: chart.tabMenu.open }"
                :style="{ top: `${chart.tabMenu.top}px`, left: `${chart.tabMenu.left}px` }"
            >
                <a href="#" @click.prevent="saveChart(chart)">Save</a>
                <a href="#" v-if="chart.id" @click.prevent="openPopup(chart, 'rename')">Rename</a>
                <a href="#" v-if="chart.id" @click.prevent="openPopup(chart, 'delete')">Delete</a>
            </div>
        </div>
        <div class="charts-tab-buttons">
            <v-btn class="btn load-chart btn--small" depressed @click="openLoadChart">
                <svg class="ico" width="8px" height="14px">
                    <use xlink:href="#ico-load-chart"></use>
                </svg>
                Load Chart
            </v-btn>
        </div>
        <Popup :class-name="showPopup ? 'open' : ''"
               @closePopup="closeSavePopup">
            <h4 class="popup-title">{{ newChartMode ? 'Save' : 'Rename' }} Chart</h4>
            <div class="popup-content">
                <v-form @submit.prevent="renameChart"
                        validation
                        ref="renameForm">
                       <v-text-field
                        v-model="renameForm.name"
                        label="Chart Name"
                        :rules="[renameForm.rules.required, renameForm.rules.max]"
                        data-vv-name="Chart Name"
                        data-vv-as="saveRenameChart"
                    />

                    <div class="buttons">
                        <v-btn type="submit" class="popup-btn">{{ newChartMode ? 'Save' : 'Rename' }}</v-btn>
                    </div>
                </v-form>
            </div>
        </Popup>
        <Popup :class-name="showPopupOnDelete ? 'open' : ''"
               @closePopup="() => {showPopupOnDelete = !showPopupOnDelete}">
            <h4 class="popup-title">Delete Chart</h4>
            <div class="popup-content">
                <p class="info-text">
                    Are you sure you want to delete this chart?
                </p>
                <div class="buttons buttons-inline">
                    <v-btn type="button" class="popup-btn" @click="deleteChart">Yes</v-btn>
                    <v-btn type="button" class="popup-btn" @click.stop="()=>{showPopupOnDelete = !showPopupOnDelete}">No</v-btn>
                </div>
            </div>
        </Popup>
    </div>
</template>

<script>

import ClickOutside from 'vue-click-outside';

import Chart from '../Charts/ChartComponent.vue';
import Popup from "../common/Popup";

export default {
    components: {
        Chart,
        Popup,
    },
    directives: {
        ClickOutside,
    },
    computed: {

        charts() {
            return this.$store.getters['chart/getCharts'];
        },
        viewCharts() {
            return this.charts
                .filter(chart => chart.state === 'view');
        },
        currentIndex() {
            return this.$store.getters['chart/getCurrentIndex'];
        },
        currentChartState() {
            return this.charts[this.currentIndex].state;
        },
    },
    data() {
        return {
            chartInitialHeight: 0,
            chartInitialWidth: 0,
            showPopup: false,
            renameForm: {
                name: '',
                id: '',
                rules: {
                    required: value => !!value || 'Chart Name is required.',
                    max: v => (v && v.length <= 100) || 'Max 100 characters.'
                }
            },
            newChartMode: false,
            showPopupOnDelete: false,
            deleteChartID: null,
            currentChartData: null
        };
    },
    mounted() {
        this.setChartInitialHeight();
        this.setChartInitialWidth();

        this.$store.dispatch('company/fetchAll');
        this.$store.dispatch('category/fetchAll');
        this.$store.dispatch('subcategory/fetchAll');
        this.$store.dispatch('class/fetchAll');
        this.$store.dispatch('brand/fetchAll');
        this.$store.dispatch('tag/fetchAll');
        this.$store.dispatch('finePrint/fetchAll');
    },
    methods: {
        chartCoverOpen(chart) {
            return chart.filters.open
                || chart.viewCompetitors.open
                || chart.viewDetails.open
                || chart.loading;
        },
        chartTitle(chart) {
            return (chart.name !== '' && typeof chart.name !== 'undefined') ? chart.name : 'Unnamed chart';
        },
        selectChart(index) {
            this.$store.commit('chart/selectChart', index);
            this.$store.dispatch('chart/redrawGraph');
        },
        addChart(event) {
            event.preventDefault();
            this.$store.commit('chart/addChart');
        },
        openLoadChart(event) {
            event.preventDefault();
            this.$store.dispatch('chart/openLoadChart');
        },
        removeChart(event, index) {
            event.preventDefault();
            event.stopPropagation();

            this.$store.commit('chart/removeChart', index);
        },
        toggleTabMenu(event, chartIndex) {
            event.preventDefault();
            const tabItem = this.$refs.tabItem[chartIndex].$el.getBoundingClientRect();

            this.$store.commit('chart/toggleTabMenu', {
                chartIndex,
                top: tabItem.top + window.scrollY + tabItem.height,
                left: tabItem.left + window.scrollX,
            });
        },
        closeTabMenu(chartIndex) {
            if (this.charts[chartIndex].tabMenu.open) {
                this.$store.commit('chart/toggleTabMenu', { chartIndex, open: false });
            }
        },
        setChartInitialWidth() {
            this.chartInitialWidth = this.$el.offsetWidth - this.$el.querySelector('.v-tabs__bar').offsetWidth - 200;
        },
        setChartInitialHeight() {
            this.chartInitialHeight = this.$el.offsetHeight - this.$el.querySelector('.v-tabs__bar').offsetHeight - 25;
        },
        openPopup(chart, type){
            this.$refs.renameForm.resetValidation();

            if (type === 'rename'){
                this.showPopup = true;
                this.renameForm.name = chart.name;

                if (!this.newChartMode) {
                    this.renameForm.id = chart.id;
                }
            }else if (type === 'delete'){
                this.showPopupOnDelete = true;
                this.deleteChartID = chart.id;
            }
        },
        closeSavePopup(){
            this.showPopup = !this.showPopup;
        },
        async renameChart() {
            const validName = await this.$refs.renameForm.validate();

            if (!validName) return;

            if (this.newChartMode){ // new chart mode

                this.currentChartData.name = this.renameForm.name;

                const validSave = await this.$store.dispatch('chart/saveChart', this.currentChartData);

                if (validSave) {
                    this.showPopup = false;
                    this.newChartMode = false;
                    this.$root.$emit('updateCharts');
                } else  {
                    this.openPopup(this.currentChartData, 'rename');
                }
            } else { // chart exist rename mode
                const renamedChart = await this.$store.dispatch('chart/renameChart', {chart: this.renameForm});

                if (renamedChart) {
                    this.showPopup = false;
                }
            }

        },
        async saveChart(chart) {
            this.currentChartData = chart;
            if (!chart.name) {
                this.newChartMode = true;
                this.openPopup(chart, 'rename');
            } else {
                const valid = await this.$store.dispatch('chart/saveChart', chart);
                if (!valid) {
                    this.newChartMode = true;
                    this.openPopup(chart, 'rename');
                }else {
                    this.newChartMode = false;
                    this.$root.$emit('updateCharts');
                }
            }
        },
        async deleteChart() {
            const chartID = this.deleteChartID;
            await this.$store.dispatch('chart/deleteChart', chartID);
            this.showPopupOnDelete = false;
        },
    },
};

</script>

<style lang="scss">
    @import '../../style/layout/ChartsPage.scss';
</style>
